import React from "react";
import { useLocation } from "react-router-dom";

import participantPageQuery from "../../participants/participant.graphql";
import LookingFor from "../../participants/components/looking-for";
import SocialLinks from "../../participants/components/social-links";
import MetaInfos from "../../participants/components/meta-infos";
import Sponsors from "../../participants/components/sponsors";
import Appearances from "../shared-components/appearances/appearances";
import Related from "../../participants/components/related/related";
import NodeWrapper from "@default/nodes/shared-components/node-wrapper";
import useNodeQuery from "@default/hooks/use-node-query";
import OpenGraphMeta from "@default/js/general-components/seo/open-graph-meta";
import { stripHtml } from "@default/js/general-components/seo/utils";
import { self } from "@default/js/config";
import SpotifyWidget from "@default/js/participants/components/spotify-widget/spotify-widget";
import DetailPageIntro from "@default/nodes/shared-components/detail-page-intro";
import CheckForChildren from "@default/lib/check-for-children";
import Credit from "@default/nodes/shared-components/credit";
import ParticipatingPersons from "@default/nodes/shared-components/participating-persons";
import MainPresenterTextInfo from "@default/nodes/shared-components/main-presenter-text-info";
import ArchivedEventInfo from "../shared-components/archived-event-info"

const Act = () => {
  const { entity, loading, error } = useNodeQuery(participantPageQuery);
  const { pathname } = useLocation();

  return (
    <NodeWrapper entity={entity} loading={loading} error={error}>
      {entity && (
        <>
          <OpenGraphMeta
            title={entity.title || entity.label}
            type="profile"
            url={self + pathname}
            description={stripHtml(entity.fieldText || entity.fieldBiography)}
            image={entity.fieldImage?.fieldMediaImage?.style?.url
              ? { url: entity.fieldImage.fieldMediaImage.style.url, alt: entity.fieldImage.fieldMediaImage.alt }
              : undefined}
            profileMeta={{
              firstName: entity.fieldFirstNameWeb,
              lastName: entity.fieldLastNameWeb,
            }}
          />
          <DetailPageIntro content={entity} mode={"act"} />
          <div className="container max-width main-container">
            <div className="row infos">
              <div className={"col-12 col-xl-8 appearances-wrapper"}>
                <Appearances
                  detailedMode={true}
                  content={entity}
                  type={"act"}
                  viewMode={"detail"}
                  showAddToCalendar={true}
                  showEndDate={true}
                />
              </div>

              <div className={"col-12 col-xl-4 meta-info-wrapper"}>
                <MetaInfos content={entity} />
              </div>
            </div>

            <div className="row text-wrapper">
              <ArchivedEventInfo content={entity}/>

              <MainPresenterTextInfo content={entity} />

              {entity?.fieldText && (
                <div className="col-12 text-wrapper">
                  <div
                    className={"text headline-subhead"}
                    dangerouslySetInnerHTML={{ __html: entity.fieldText }}
                  />
                </div>
              )}

              <Credit content={entity} />
            </div>

            <div className="row with-gaps">
              <CheckForChildren classes={"col-12 col-lg-6 left-col"}>
                <SpotifyWidget content={entity} />

                <LookingFor content={entity} />

                <Sponsors content={entity} />
              </CheckForChildren>

              <CheckForChildren classes={"col-12 col-lg-6 right-col"}>
                <SocialLinks content={entity} />
              </CheckForChildren>

              <ParticipatingPersons content={entity} />
            </div>
          </div>
          <CheckForChildren className="container-fluid related-container">
            <Related content={entity} type={"act"} />
          </CheckForChildren>
        </>
      )}
    </NodeWrapper>
  );
};

Act.propTypes = {};

export default Act;
